import router from "./index";

const isSubDomainMultitenancyType = process.env.VUE_APP_MULTITENANCY_TYPE === "Subdomain";

const getBackend = (backend?: string): string => {
    if (isSubDomainMultitenancyType) {
        const splitedHost = window.location.host.split(".");
        return splitedHost.length > 2 ? splitedHost[0] : backend || "";
    }
    else {
        return backend || router.currentRoute.params.backend || ''
    }
}

const noEventId = 'noevent';

export { getBackend, isSubDomainMultitenancyType, noEventId }
